import axios from 'axios';

const DEFAULT_FDCP_API_URL = 'https://api.fifa.com/api/v3';

const FDCP_API_URL = process.env.REACT_APP_FDCP_API_URL || DEFAULT_FDCP_API_URL;

if (FDCP_API_URL === undefined) {
    throw new Error('FDCP API URL not defined');
}

export const fdcpApi = axios.create({
    method: 'get',
    baseURL: `${FDCP_API_URL}`,
    headers: {
        'Content-Type': 'application/json',
    },
});

fdcpApi.interceptors.request.use(
    (request) => request,
    (error) => {
        return Promise.reject(error);
    },
);

fdcpApi.interceptors.response.use(
    (request) => request,
    (error) => {
        return Promise.reject(error);
    },
);

export default fdcpApi;
